import axios from "axios"
import { VERSION } from "../config";
const prefixUri = `/mall/${VERSION}/service_area`;
const isLocalMock = false;
export default {

    /**
     * 获取所有的服务城市
     * GET /v1.0/service_area/list
     * @post
     */
    list(option = undefined) {
        if (0 || option && option.isLocalMock || isLocalMock) {
            console.log('API mock list');
            return new Promise(r => {
                r(
                    [
                        {
                            "cityName": "北京",
                            "id": "string1",
                            "provinceName": "string1"
                        },
                        {
                            "cityName": "福州",
                            "id": "string2",
                            "provinceName": "string2"
                        },
                        {
                            "cityName": "厦门",
                            "id": "string3",
                            "provinceName": "string3"
                        }
                    ]
                )
            });
        } else {
            return axios({
                url: `${prefixUri}/list`,
                method: "GET",
                ...option
            })
        }
    },
    /**
     * 根据城市id查询服务区域
     * GET /v1.0/service_area/boundary/{serviceCityId}
     * @post
     */
    boundary(serviceCityId, option = undefined) {
        if (0 || option && option.isLocalMock || isLocalMock) {
            console.log('API mock boundary');
            return new Promise(r => {
                r(
                    { "boundaryList": [[[118.1077199997008, 24.4854740004412], [118.1127199997008, 24.492140667107865], [118.1177199997008, 24.4954740004412], [118.10521999970081, 24.4929740004412]], [[118.1127199997008, 24.4854740004412], [118.1177199997008, 24.492140667107865], [118.12271999970079, 24.4954740004412], [118.1102199997008, 24.4929740004412]]], "serviceCityId": "string3", "id": "string3" }
                    // {
                    //     "boundaryList": [
                    //         [
                    //             {}
                    //         ]
                    //     ],
                    //     "id": "string"
                    // }
                )
            });
        } else {
            return axios({
                url: `${prefixUri}/boundary/${serviceCityId}`,
                method: "GET",
                ...option
            })
        }
    },
}


// WEBPACK FOOTER //
// ./src/apis/src/serviceArea.js